import React from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'; // Heroicons

const NotFoundPage = () => {
  return (
    <div className="flex items-center justify-center h-screen bg-gradient-to-r from-gray-100 to-blue-100">
      <div className="text-center animate-fade-in-up">
        <div className="inline-flex items-center justify-center w-24 h-24 bg-red-100 rounded-full shadow-md mb-6">
          <ExclamationTriangleIcon className="w-12 h-12 text-red-500 animate-pulse" />
        </div>
        <h1 className="text-5xl font-bold text-gray-800 mb-2">404</h1>
        <p className="text-lg text-gray-600 mb-4">Oops! Page not found.</p>
        <p className="text-sm text-gray-500 mb-6">The page you’re looking for doesn’t exist or has been moved.</p>
        <a
          href="/"
          className="px-6 py-2 text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow transition-all duration-300"
        >
          Go Home
        </a>
      </div>
    </div>
  );
};

export default NotFoundPage;
